import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Icon } from '@manychat/icons'

/**
 * Renders ManychatIcon to a string that can be used in the FlowChart canvas
 */
export const convertToIconString = (
  icon: Icon,
  {
    size,
    color,
  }: {
    size?: number
    color?: string
  },
) => {
  const IconComponent = icon
  return renderToStaticMarkup(React.createElement(IconComponent, { size, color }))
}
